var _pattern, _rect, _rect2, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTowerco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 250",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#2B2D42",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1A1B2E",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "towerGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#EF233C",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#D90429",
      stopOpacity: 1
    }
  })), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "wavePattern",
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,10 Q5,0 10,10 Q15,20 20,10",
    fill: "none",
    stroke: "#8D99AE",
    strokeWidth: 1,
    opacity: 0.2
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 250,
    fill: "url(#bgGradient)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 250,
    fill: "url(#wavePattern)",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40, 125)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    fontFamily: "Arial Black, sans-serif",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontSize: 55,
    letterSpacing: 3
  }, "\n        TOWERCO\n      ")), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 15,
    width: 320,
    height: 3,
    fill: "url(#towerGradient)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    fontFamily: "Arial Black, sans-serif",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 50,
    fontSize: 15,
    letterSpacing: 3
  }, "\n        IA G\xE9n\xE9rative\n      "), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 70,
    fontSize: 15,
    letterSpacing: 3
  }, "\n        Traitement de photos\n      ")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(315, 120)",
    fill: "none",
    stroke: "#8D99AE",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,100 L15,0 L30,100",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 25,
    x2: 25,
    y2: 25,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 50,
    x2: 23,
    y2: 50,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 75,
    x2: 21,
    y2: 75,
    opacity: 0.6
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(300, 120)",
    stroke: "url(#towerGradient)",
    fill: "none",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Q30,-20 60,0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,10 Q30,-5 50,10",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,20 Q30,5 40,20",
    strokeWidth: 2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#EF233C",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 20,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 20,
    x2: 40,
    y2: 40,
    stroke: "#EF233C",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 40,
    x2: 60,
    y2: 20,
    stroke: "#EF233C",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowerco);
export default __webpack_public_path__ + "static/media/towerco.b102eb63a93f13bdf428c4f1687e56d5.svg";
export { ForwardRef as ReactComponent };